module.exports = __webpack_public_path__ + "static/img/icired.5156a896.png";